import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';

export const SURVEY_DATA_ACTIONS = {
  FETCH_SURVEY_DATA: "FETCH_SURVEY_DATA",
  SAVED_SURVEY_DATA: "SAVED_SURVEY_DATA",
  CALL_DISAGG_API: "CALL_DISAGG_API",
  CHECK_DISAGG_STATUS: "CHECK_DISAGG_STATUS"
}

export function fetchSurveyData(userId, locale) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/users/' + userId + '/homes/1/survey', {
      params: {
        locale: locale
      }
    }).then(
      (response) => {
        dispatch({
          type: "FETCH_SURVEY_DATA",
          payload: response.data.payload
        })
      }
    )
  }
}

export function saveSurveyData(payload, userId) {
  return dispatch => {
    axios.put(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/users/' + userId + '/homes/1/survey', payload).then(
      () => {
        dispatch({
          type: "SAVED_SURVEY_DATA"
        })
      }
    )
  }
}

export function callDisaggApi(userId) {
  return dispatch => {
    axios.post(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/submit-survey/users/' + userId).then(
      (response) => {
        dispatch({
          type: "CALL_DISAGG_API",
          payload: response.data.payload
        })
      }
    )
  }
}

export function checkIfDisaggFinished(userId, timestamp) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/submit-survey/users/' + userId + '/status', {
      params: {
        "survey-submission-timestamp": timestamp
      }
    }).then(
      (response) => {
        dispatch({
          type: "CHECK_DISAGG_STATUS",
          payload: response.data.payload
        })
      }
    )
  }
}
